import { render, staticRenderFns } from "./layout-member.vue?vue&type=template&id=77c5ac7b&scoped=true&"
import script from "./layout-member.vue?vue&type=script&lang=js&"
export * from "./layout-member.vue?vue&type=script&lang=js&"
import style0 from "./layout-member.vue?vue&type=style&index=0&id=77c5ac7b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c5ac7b",
  null
  
)

export default component.exports